import { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate"; // Adjusted import path
// import useAxiosPrivate from "../hooks/useAxiosPrivate";
// import axios from '../../api/axios';
// import { useNavigate, useLocation } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import { DragDropContext, Draggable } from "@hello-pangea/dnd";
import { StrictModeDroppable as Droppable } from "../../helpers/StrictModeDroppable";
import { formatDate, formatItems } from "../../helpers/utils";
import styles from "./Admin.module.css";
import _ from 'lodash';
import { Switch } from "@mui/material";
import LoadingModal from "../LoadingModal";


function SurveyGroup({ surveys, type, category, handleOnDragEnd, onEditSurvey }) {
    const title = category ? `${type} > ${category}` : type;
    const id = category ? `${type}|${category}` : type;
    if ((surveys.length > 1)) {
        return (
            <div>
                <h3>{title}</h3>
                <div className="surveys-list-container">
                    <DragDropContext onDragEnd={handleOnDragEnd}>
                        <Droppable droppableId={id}>
                            {(provided) => (
                                <div className="surveys-list" {...provided.droppableProps} ref={provided.innerRef}>
                                    {
                                        surveys.map((survey, i) => {
                                            return (
                                                <Draggable key={i} draggableId={i.toString()} index={i}>
                                                    {(provided) => (
                                                        <div title={`${formatItems(survey.questions, "questions")}, last edited ${formatDate(new Date((Date.parse(survey.lastModified))))}`} key={i} className={survey.status === "archived" ? "surveys-list-item archived" : "surveys-list-item"} {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
                                                            <label className="title">{survey.title}</label>
                                                            <button className="edit" onClick={e => onEditSurvey(survey.surveyId)}></button>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            )
                                        })
                                    }
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                </div>
            </div>
        )
    } else if ((surveys.length === 1)) {
        const survey = surveys[0];
        return (
            <div>
                <h3>{title}</h3>
                <div className="surveys-list-container">
                    <div title={`${formatItems(survey.questions, "questions")}, last edited ${formatDate(new Date((Date.parse(survey.lastModified))))}`} className={survey.status === "archived" ? "surveys-list-item archived not-draggable" : "surveys-list-item not-draggable"}>
                        <label className="title">{survey.title}</label>
                        <button className="edit" onClick={e => onEditSurvey(survey.surveyId)}></button>
                    </div>
                </div>
            </div>
        )
    }
}

const filteredSurveys = (surveys, hideInactive) => {
    if (hideInactive) {
        return surveys.filter(survey => survey.status === "active");
    }
    return surveys;
}
const Surveys = () => {

    const navigate = useNavigate();

    const axiosPrivate = useAxiosPrivate();

    const [profileSurveys, setProfileSurveys] = useState([]);
    const [benchmarkingSurveys, setBenchmarkingSurveys] = useState([]);
    const [insightsSurveys, setInsightsSurveys] = useState({});
    const [popupSurveys, setPopupSurveys] = useState([]);

    const [insightsCategories, setInsightsCategories] = useState([]);

    const [dataLoaded, setDataLoaded] = useState(false);

    const [isSaving, setIsSaving] = useState(false);

    const [hideInactive, setHideInactive] = useState(true);

    const toggleFilter = () => {
        setHideInactive(prev => !prev);
    }

    const parseSurveys = (surveys) => {
        const profileSurveys = [];
        const popupSurveys = [];
        const benchmarkingSurveys = [];
        const insightsSurveys = {};
        const uniqueCategories = {};
        const insightsCategories = [];
        for (let survey of surveys) {
            const type = survey.type;
            if (type === "Profile") {
                profileSurveys.push(survey);
            } else if (type === "Pop-up") {
                popupSurveys.push(survey);
            } else if (type === "Benchmarking") {
                benchmarkingSurveys.push(survey);
            } else if (type === "Insights") {
                const category = survey.pollCategory;
                if (uniqueCategories[category] === undefined) {
                    uniqueCategories[category] = true;
                    insightsCategories.push(category);
                    insightsSurveys[category] = [];
                }
                insightsSurveys[category].push(survey);
            }
        }
        if (surveys.length > 0) {
            setProfileSurveys(_.cloneDeep(profileSurveys));
            setPopupSurveys(_.cloneDeep(popupSurveys));
            setBenchmarkingSurveys(_.cloneDeep(benchmarkingSurveys));
            setInsightsCategories(insightsCategories)
            setInsightsSurveys(_.cloneDeep(insightsSurveys));
            setDataLoaded(true);
            setIsSaving(false);
        }

    }

    const handleOnDragEnd = (result) => {

        if (!result?.destination) return;

        const sourceIndex = result.source.index;
        const destinationIndex = result.destination.index;

        const params = (result.destination.droppableId).split("|");
        const type = params[0];
        const category = params[1];

        // console.log(`type: ${type} category: ${category} index: ${result.source.index} destination: ${result.destination.index} id: ${result.destination.droppableId}`);

        let surveys;

        switch (type) {
            case "Benchmarking":
                surveys = benchmarkingSurveys;
                break;
            case "Insights":
                if (category) {
                    surveys = insightsSurveys[category];
                } else {
                    console.error("Missing category for Insights type");
                }
                break;
            default:
                console.error(`Unknown type: ${type}`);
                return;
        }

        const filtered = filteredSurveys(surveys, hideInactive);

        const mappedSourceIndex = surveys.findIndex(survey => survey.surveyId === filtered[sourceIndex].surveyId);

        const mappedDestinationIndex = surveys.findIndex(survey => survey.surveyId === filtered[destinationIndex].surveyId);

        const newSurveys = _.cloneDeep(surveys);
        const [reorderedSurvey] = newSurveys.splice(mappedSourceIndex, 1);
        newSurveys.splice(mappedDestinationIndex, 0, reorderedSurvey);

        switch (type) {
            case "Benchmarking":
                setBenchmarkingSurveys(newSurveys);
                break;
            case "Insights":
                setInsightsSurveys(prev => {
                    const updatedInsights = { ...prev };
                    updatedInsights[category] = newSurveys;
                    return updatedInsights;
                });
                break;
            default:
                console.error(`Unknown/unexpected type: ${type}`);
                return;
        }

    }
    const onEditSurvey = (surveyId) => {
        navigate(`/survey/edit/${surveyId}`);
    }
    const saveChanges = async () => {

        const displayOrder = [];

        for (let surveys of [profileSurveys, benchmarkingSurveys]) {
            let order = 1;
            for (let survey of surveys) {
                displayOrder.push({
                    surveyId: survey.surveyId,
                    displayOrder: order++
                })
            }
        }
        for (let category of insightsCategories) {
            let surveys = insightsSurveys[category];
            let order = 1;
            for (let survey of surveys) {
                displayOrder.push({
                    surveyId: survey.surveyId,
                    displayOrder: order++
                })
            }
        }

        const json = {
            displayOrder
        }

        setIsSaving(true);

        try {
            const response = await axiosPrivate.patch(`/surveys`,
                JSON.stringify(json),
                {
                    headers: { 'Content-Type': 'application/json' }
                }
            );

            parseSurveys(response.data);

        } catch (err) {
            console.log(err);
            // if (!err?.response) {
            //     setErrMsg('No Server Response');
            // } else if (err.response?.status === 409) {
            //     setErrMsg('Email Taken');
            // } else {
            //     setErrMsg('Registration Failed')
            // }
            // errRef.current.focus();
        }

    }

    useEffect(() => {
        let isMounted = true;

        const getSurveysController = new AbortController();

        const getSurveys = async () => {

            try {
                const response = await axiosPrivate.get('/surveys', {
                    signal: getSurveysController.signal
                });
                if (isMounted) {
                    parseSurveys(response.data);
                }
            } catch (err) {
                if (isMounted) {
                    console.error(err);
                    let location = null;
                    if (err.response?.status === 403) {
                        navigate('/login', { state: { from: location }, replace: true });
                    }
                }
            }
        }

        getSurveys();

        return () => {
            isMounted = false;
            getSurveysController.abort();
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    if (!dataLoaded) {
        return <LoadingModal />;
    }

    console.log(`Surveys: render at ${new Date().getTime()}`);

    return (
        <section className={styles.admin}>
            <div className="toolbar">
                <p><Link to="/admin">Admin</Link> &gt; Surveys</p>
                <div className={styles.filterContainer}>
                    <label>Hide inactive surveys:</label>
                    <Switch checked={hideInactive} onChange={toggleFilter} />
                </div>
            </div>
            <SurveyGroup surveys={filteredSurveys(profileSurveys, hideInactive)} type={"Profile"} handleOnDragEnd={handleOnDragEnd} onEditSurvey={onEditSurvey} />
            <SurveyGroup surveys={filteredSurveys(benchmarkingSurveys, hideInactive)} type={"Benchmarking"} handleOnDragEnd={handleOnDragEnd} onEditSurvey={onEditSurvey} />
            {
                insightsCategories.map((insightsCategory, j) => {
                    const filtered = filteredSurveys(insightsSurveys[insightsCategory], hideInactive);
                    // console.log(`insightsCategory: ${insightsCategory} surveys: ${insightsSurveys[insightsCategory].length} filtered: ${filtered.length}`);
                    return (
                        (filtered.length > 0) &&
                        <SurveyGroup key={j} surveys={filtered} type={"Insights"} category={insightsCategory} handleOnDragEnd={handleOnDragEnd} onEditSurvey={onEditSurvey} />
                    )
                })
            }
            <SurveyGroup surveys={filteredSurveys(popupSurveys, hideInactive)} type={"Pop-up"} handleOnDragEnd={handleOnDragEnd} onEditSurvey={onEditSurvey} />
            <button disabled={isSaving} onClick={saveChanges}>{isSaving ? "Saving..." : "Save changes"}</button>
        </section>
    );

};

export default Surveys;